/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListDepositsOptions, ListDepositsResponses } from '../types/ListDeposits'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Lists USDC deposits ordered by observed_at descending. Admin users may list deposits for any user (or all users); non-admin users may only list their own deposits.
 * @summary List USDC deposits
 * {@link /v1/web3/deposits}
 */
export function listDeposits<ThrowOnError extends boolean = true>(
  options: Options<ListDepositsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListDepositsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/web3/deposits',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListDepositsResponses, ThrowOnError>>,
  )
}
